var _circle, _line, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHealthcareSpace = function SvgIconHealthcareSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-no-fill": "true",
    cx: 16,
    cy: 6,
    r: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    "data-no-fill": "true",
    x1: 16,
    y1: 21,
    x2: 16,
    y2: 27
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    "data-no-fill": "true",
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "M22 5.5V6c0 3.3-2.7 6-6 6s-6-2.7-6-6v-.5L3 12l13 4 13-4-7-6.5zM10.7 19.7c-.5-.4-.7-.8-.7-1.2 0-1.4 2.7-2.5 6-2.5s6 1.1 6 2.5-2.7 2.5-6 2.5M13.3 24.5c-.8-.4-1.3-.9-1.3-1.5 0-1.1 1.8-2 4-2M16 25c1.7 0 3 .9 3 2s-1.3 2-3 2-3-.9-3-2"
  })));
};
export { SvgIconHealthcareSpace as ReactComponent };
export default "data:image/svg+xml;base64,PHN2Zw0KICAgICAgICB2ZXJzaW9uPSIxLjEiDQogICAgICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiDQogICAgICAgIHZpZXdCb3g9IjAgMCAzMiAzMiINCiAgICAgICAgeG1sOnNwYWNlPSJwcmVzZXJ2ZSINCiAgICAgICAgZmlsbD0ibm9uZSINCiAgICAgICAgc3Ryb2tlPSIjMDAwIg0KICAgICAgICBzdHJva2Utd2lkdGg9IjIiDQogICAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCINCiAgICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCINCiAgICAgICAgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIg0KPg0KICAgIDxjaXJjbGUgZGF0YS1uby1maWxsPSJ0cnVlIiBjeD0iMTYiIGN5PSI2IiByPSIyIi8+DQogICAgPGxpbmUgZGF0YS1uby1maWxsPSJ0cnVlIiB4MT0iMTYiIHkxPSIyMSIgeDI9IjE2IiB5Mj0iMjciLz4NCiAgICA8bGluZSBkYXRhLW5vLWZpbGw9InRydWUiIHgxPSIxNiIgeTE9IjEyIiB4Mj0iMTYiIHkyPSIyMSIvPg0KICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSINCiAgICAgICAgICBkPSJNMjIsNS41YzAsMC4yLDAsMC4zLDAsMC41YzAsMy4zLTIuNyw2LTYsNnMtNi0yLjctNi02YzAtMC4yLDAtMC4zLDAtMC41TDMsMTJsMTMsNGwxMy00TDIyLDUuNXoiLz4NCiAgICA8cGF0aCBkYXRhLW5vLWZpbGw9InRydWUiIGQ9Ik0xMC43LDE5LjdjLTAuNS0wLjQtMC43LTAuOC0wLjctMS4yYzAtMS40LDIuNy0yLjUsNi0yLjVzNiwxLjEsNiwyLjVTMTkuMywyMSwxNiwyMSIvPg0KICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZD0iTTEzLjMsMjQuNUMxMi41LDI0LjEsMTIsMjMuNiwxMiwyM2MwLTEuMSwxLjgtMiw0LTIiLz4NCiAgICA8cGF0aCBkYXRhLW5vLWZpbGw9InRydWUiIGQ9Ik0xNiwyNWMxLjcsMCwzLDAuOSwzLDJzLTEuMywyLTMsMnMtMy0wLjktMy0yIi8+DQo8L3N2Zz4=";